// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"svgIcon___wrapper___3zWFP"};